import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'
import moment from 'moment'
import { banner, breadcrumb } from '../../../../../styleguide/components/components/pageHeader'
import { getImageSize } from '../../../utils/extra_images.mod'
import { decodeHTMLEntities } from '../../../../../helpers'

export type HeroAttributes = {
  blockName: 'vidda/hero'
  title: string
  intro?: string
  image?: WordPress.MediaResponse
  image_alt?: string
  show_image: boolean
  header_type: 'header-1' | 'header-2' | 'header-3'
  color?: "product--comfort" | "product--elan" | "product--leven" | "product--woon"
  show_alert?: boolean
  alert_text?: string
}

const mapHeaderType = (
  header_type: 'header-1' | 'header-2' | 'header-3'
): 'home' | 'page' | 'product' => {
  if (header_type == 'header-1') return 'home'
  if (header_type == 'header-2') return 'product'
  return 'page' // header-3
}

export interface HeroInterface {
  blockName: 'vidda/hero'
  attrs: HeroAttributes
}

export type HeroBlockProps<extra_images> = HeroAttributes

export type HeroBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  intro_classname: string
  visual_classname: string
}>


export function HeroBlock<customBlockData, extra_images>(
  props: HeroBlockProps<extra_images>,
  options?: { style: HeroBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => {

        let real_page_type = public_state.page.page.kind == 'loaded' ? public_state.page.page.value.extra_data.post.type : 'page'

        let page_type = mapHeaderType(props.header_type)
        let date_posted = public_state.page.page.kind == 'loaded' ? moment(public_state.page.page.value.extra_data.date) : undefined

        return <>
          {props.show_alert && (
            <div className="ph__alert">
              {decodeHTMLEntities(props.alert_text) || 'Let op: momenteel zijn wij door een storing helaas slecht telefonisch bereikbaar.'}
            </div>
          )}
          <header className={`page-header ph ph--${page_type}${(page_type == 'page' || page_type == 'product') ? ' ph--secondary' : ''}${props.image ? ' ph--image' : ''} ${page_type == 'product' ? props.color ? props.color : 'product--default' : ''}`}>
            <div className={`ph__outer container${page_type == 'home' ? ' container--xl' : ''}`}>
              <div className={`ph__inner${props.show_image ? ' pg__inner--img' : ''} pg__inner--${page_type == 'product' ? 'product' : 'other'}`}>
                <div className="ph__content content">
                  <div className="ph__header">
                    {props.title && <h1 className="ph__title typo--xl">{props.title}</h1>}
                    {real_page_type == 'update' && date_posted &&
                      <time
                        className="ph__date"
                        dateTime={date_posted.local().format('YYYY-MM-DD hh:mm:ss')}
                      >
                        {date_posted.local().format('DD MMMM YYYY')}
                      </time>
                    }
                    {page_type == 'page' || page_type == 'product' && props.intro &&
                      <p className="ph__intro" dangerouslySetInnerHTML={{ __html: props.intro }} />
                    }
                  </div>
                </div>
                {props.show_image && props.image && props.image.source_url &&
                  <div className="ph__visual visual">
                    {page_type == 'page' || page_type == 'product' ?
                      <img className="ph__image" src={getImageSize(props.image, '1160x1160')} width="1160" height="1160" alt={props.image.alt_text} />
                      :
                      <img className="ph__image" src={getImageSize(props.image, '1800x1160')} width="1800" height="1160" alt={props.image.alt_text} />
                    }
                  </div>
                }
              </div>
              {page_type == 'home' &&
                // It is okay to hardcode this. // TODO: Put real links in here 
                banner([
                  { title: 'Ik zoek een hypotheek', url: '/ik-zoek-een-hypotheek' },
                  { title: 'Ik heb een hypotheek', url: '/ik-heb-een-hypotheek' },
                  { title: 'Ik ben een adviseur', url: '/adviseurs' }
                ])
              }
              {
                s.custom_page_data &&
                s.custom_page_data.v.kind == 'r' &&
                s.custom_page_data.v.v.post.breadcrumb &&
                s.custom_page_data.v.v.post.breadcrumb.itemListElement &&
                !s.custom_page_data.v.v.post.is_front &&
                (
                  breadcrumb(s.custom_page_data.v.v.post.breadcrumb.itemListElement.map(crumb => crumb.item['@id'] ? ({ title: crumb.item.name, url: crumb.item['@id'] }) : undefined).filter(item => item != undefined))
                )
              }
              {real_page_type == 'update' && props.intro &&
                <div className="ph__intro-wrap container grid--block">
                  <div dangerouslySetInnerHTML={{ __html: props.intro }}></div>
                </div>
              }
            </div>
          </header>
        </>
      }
    })
  }
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/heroBlock.mod.tsx